import { useUserContext } from '@fortem-monorepo/react-spa'
import type { MarketSummary } from '@fortem-monorepo/web-sdk'

import { DataGridBlock } from '@/components/content-blocks/blocks/data-grid/DataGridBlock'
import { dataGridOverride } from '@/components/content-blocks/blocks/data-grid/types'
import { MarketSummarySidebar } from '@/pages/instruments/market-summary/components/MarketSummarySidebar'
import { createMarketSummaryColumnDefs } from '@/pages/instruments/market-summary/market-summary-columns'
import { useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'

const columnWidths: Record<string, number> = {
  long_name: 500,
  unique_identifier: 200,
}

export interface MarketSummaryReportTabProps {}

export const MarketSummaryReportTab: React.FC<MarketSummaryReportTabProps> = ({}) => {
  const { reportQuery, reportSections } = useMarketSummaryContext()
  const userContext = useUserContext()

  return (
    <div className="flex flex-1 h-full w-full">
      <MarketSummarySidebar />
      <div className={'p-4 space-y-4 w-full'}>
        {reportSections.map((section) => {
          const data = (reportQuery.data?.block.rows ?? []).filter((d) => d.section === section)

          return (
            <div id={section} key={section}>
              <DataGridBlock
                query={reportQuery}
                block={{ ...reportQuery.data?.block!, rows: data, title: section }}
                context={{ userContext }}
                override={dataGridOverride<MarketSummary.ReportRow>((_, block) => ({
                  columnDefs: createMarketSummaryColumnDefs(block).map((column) => {
                    const width = columnWidths[column.field ?? ''] ?? undefined

                    return {
                      ...column,
                      width,
                      suppressAutoSize: true,
                    }
                  }),
                }))}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
